import { render } from "./InputMobileCode.vue?vue&type=template&id=83585ae4&lang=pug"
import script from "./InputMobileCode.vue?vue&type=script&lang=js"
export * from "./InputMobileCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__